export const zIndex = {
  auto: "auto",
  base: 0,
  dropdown: 1000,
  sticky: 1020,
  fixed: 1030,
  modal: 1040,
  popover: 1050,
  tooltip: 1060
};



// WEBPACK FOOTER //
// ./src/design-system/theme/zIndex.js